import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0B1426]/95 backdrop-blur-sm border-b border-white/10">
      <nav className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-8">
        <div className="flex h-14 sm:h-16 items-center justify-center">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://freepngimg.com/save/168836-currency-crypto-digital-free-hd-image/2000x458" 
              alt="Crypto.com" 
              className="h-8 w-auto sm:h-10 md:h-12"
            />
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default Header;
